var map = {
	"./bank-transfer.svg": 1001,
	"./betnearn-ico.svg": 1002,
	"./birthday-bonus-ico.svg": 1003,
	"./birthday.svg": 1004,
	"./bonus-code-ico.svg": 1005,
	"./bonus-ico.svg": 1006,
	"./bonus-received-ico.svg": 1007,
	"./bonus.svg": 1008,
	"./business-account-upgrade-ico.svg": 1009,
	"./check-in-daily-ico.svg": 1010,
	"./checked.svg": 1011,
	"./cloud-pointer.svg": 1012,
	"./coin.svg": 1013,
	"./crypto.svg": 1014,
	"./daily-bonus-ico.svg": 1015,
	"./daily-limit.svg": 1016,
	"./deposit-delay-bonus-ico.svg": 1017,
	"./e-wallet.svg": 1018,
	"./earn-x33-coin-ico.svg": 1019,
	"./email.svg": 1020,
	"./facebook.svg": 1021,
	"./feedback.svg": 1022,
	"./first-bet-ico.svg": 1023,
	"./games-rebate-ico.svg": 1024,
	"./info.svg": 1025,
	"./instagram.svg": 1026,
	"./live-casino-rebate-ico.svg": 1027,
	"./lucky-spin-ico.svg": 1028,
	"./messenger.svg": 1029,
	"./mobile-app-deposit-ico.svg": 1030,
	"./monthly-cash.svg": 1031,
	"./msg-activity.svg": 1032,
	"./msg-ann.svg": 1033,
	"./msg-notice.svg": 1034,
	"./new-icon.svg": 1035,
	"./people-ico.svg": 1036,
	"./quick-pay.svg": 1037,
	"./rescue-bonus-ico.svg": 1038,
	"./rescue-lc-ico.svg": 1039,
	"./rescue-slots-ico.svg": 1040,
	"./return.svg": 1041,
	"./sc-bc-active-ico.svg": 1042,
	"./sc-bc-ico.svg": 1043,
	"./sc-bi-active-ico.svg": 1044,
	"./sc-bi-ico.svg": 1045,
	"./sc-mail-active-ico.svg": 1046,
	"./sc-mail-ico.svg": 1047,
	"./sc-mp-active-ico.svg": 1048,
	"./sc-mp-ico.svg": 1049,
	"./sc-pin-active-ico.svg": 1050,
	"./sc-pin-ico.svg": 1051,
	"./slots-rebate-ico.svg": 1052,
	"./sports-rebate-ico.svg": 1053,
	"./telegram.svg": 1054,
	"./twitter.svg": 1055,
	"./vip-up-level-ico.svg": 1056,
	"./vip-weekly-bonus.svg": 1057,
	"./wallet-balance-interest-ico.svg": 1058,
	"./wallet-ico.svg": 1059,
	"./weekly-tournament-ico.svg": 1060,
	"./welcome-bonus-188-ico.svg": 1061,
	"./welcome-bonus-ico.svg": 1062,
	"./whatsapp.svg": 1063,
	"./withdrawal-delay-bonus-ico.svg": 1064,
	"./withdrawal.svg": 1065,
	"./x33-coin.svg": 1066
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64;